import React, { useState, useEffect, useMemo } from 'react'

import './IncomeExtended.scss'

import axios from 'axios'

import { useHistory, Link } from "react-router-dom";

import { ArrowLeft } from "react-feather";

import MobileHeader from '../../components/commonComponents/mobileHeader/MobileHeader'

import { hostDetect } from '../../config/envConfig'

import { setAlert } from '../../redux/actions/alertActions'

import { connect } from 'react-redux'

import DatePicker from './DatePicker/DatePicker'
import GroupBy from './GroupBy/GroupBy'
import MultiSelect from './MultiSelect/MultiSelect'
import SelectBy from "./SelectBy/SelectBy";
import StatsChart from './Chart/Chart'
import Table from "./Table/Table";

import { useLocation } from "react-router-dom";


const PageIncomeExtended = ({ currentSiteID, startDate_store, endDate_store, setAlert }) => {

  const [apiLoading, setApiLoading] = useState(false)

  const [data, setData] = useState(null)

  const [widgetList, setWidgetList] = useState([])

  const [selectedWidgets, setSelectedWidgets] = useState([])

  const [startDate, setStartDate] = useState(startDate_store)
  const [endDate, setEndDate] = useState(endDate_store)
  const [groupBy, setGroupBy] = useState('day')

  const location = useLocation();
    
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");

  const getType = () =>{
    if(type){
      return `?type=${type}`
    }
    return ''
  }

  let history = useHistory();

	const handleBackClick = () => {
		history.goBack();
	}

  const getStats = async () => {
    setApiLoading(true)

    try {

      const raw_data = await axios.get(`${hostDetect('api')}/site-statistics/income?site_id=${currentSiteID}&start_date=${startDate}&end_date=${endDate}&group=${groupBy}${getType()}`, {
        withCredentials: true
      })
      
      const response = await raw_data.data

      if(response.success){

        const widgets = response.data.widgets.map(item => {
          return {
            id: item.id,
            name: item.name
          }
        })
        setWidgetList(widgets)
        setData(response.data.widgets)

      } else {
        let errMessage = response.data.message;
        setAlert('error', errMessage);
      }

    } catch(e) {
      setAlert('error', 'Не получилось отправить запрос!');
    } finally {
      setApiLoading(false)
    }
  }

  useEffect(() => {
    setData(null);
    setSelectedWidgets([]);
    setWidgetList([]);
  }, [currentSiteID]);

  useEffect(() => {
    if (currentSiteID) {
      getStats();
    }
  }, [currentSiteID, startDate, endDate, groupBy]);


  // вкл/выкл виджет в селекте
  const handleChange = (selected) => {
    setSelectedWidgets(selected)
  };

  // выкл виджет из тег-списка
  const removeWidget = (id) => {
    setSelectedWidgets((prev) =>
      prev.filter((widgetId) => widgetId !== id)
    );
  };

  const result = data && data.filter(item => selectedWidgets.includes(item.id));


  const ZERO_VALUES = {
    ad_clicks: 0,
    clicks: 0,
    cpm: 0,
    ctr: 0,
    exchange_clicks: 0,
    income: 0,
    organic_clicks: 0,
    profit: 0,
    returned: 0,
    view_percent: 0,
    views: 0,
    visits: 0
  };

  const toNumber = (value) => {
    const number = Number(value);

    return Number.isFinite(number) ? number : 0;
  };

  function calculateMetrics(target) {
    // CTR
    if (target.views > 0) {
      target.ctr = (target.clicks / target.views) * 100;
    } else {
      target.ctr = 0;
    }

    // CPM
    if (target.views > 0) {
      target.cpm = (target.income / target.views) * 1000;
    } else {
      target.cpm = 0;
    }

    // Видимость %
    if (target.visits > 0) {
      target.view_percent = (target.views / target.visits) * 100;
    } else {
      target.view_percent = 0;
    }

    return target;
  }

  function sumItems(items) {
    const result = {
      data: {},
      total: { ...ZERO_VALUES }
    };

    for (const item of items) {
      // Данные по дням
      for (const [date, values] of Object.entries(item.data || {})) {
        if (!result.data[date]) {
          result.data[date] = { ...ZERO_VALUES };
        }

        for (const [key, value] of Object.entries(values || {})) {
          // cpm и ctr пока не трогаем
          if (key === "cpm" || key === "ctr" || key === "view_percent") {
            continue;
          }

          result.data[date][key] = (result.data[date][key] || 0) + toNumber(value);
        }
      }

      // total
      for (const [key, value] of Object.entries(item.total || {})) {
        if (key === "cpm" || key === "ctr" || key === "view_percent") {
          continue;
        }

        result.total[key] = (result.total[key] || 0) + toNumber(value);
      }
    }

    // Пересчитываем показатели для каждого дня
    for (const date of Object.keys(result.data)) {
      calculateMetrics(result.data[date]);
    }

    // Пересчитываем общие показатели
    calculateMetrics(result.total);

    return result;
  }

  const result_summ = result && sumItems(result);


  const selectedWidgetsList = widgetList.filter((item) =>
    selectedWidgets.includes(item.id)
  );

  // только активные виджеты
  const activeWidgetIds = useMemo(() => {
    if (!data) {
      return [];
    }

    return data
      .filter((widget) => {
        const visits = Number(widget.total?.visits) || 0;
        const views = Number(widget.total?.views) || 0;
        const clicks = Number(widget.total?.clicks) || 0;

        return visits > 0 || views > 0 || clicks > 0;
      })
      .map((widget) => widget.id);
  }, [data]);

  return (
    <div className="page-income-extended">
      <div className="page-income-extended__wrap">

        <MobileHeader />

        {
          apiLoading ? 
            <div className="loader__small">
                Загрузка данных...
            </div> : null
        }

        <div className="page-income-extended__back-btn">
          <button className="btn w-sm mb-1 btn-secondary" onClick={handleBackClick}>
            <ArrowLeft size={15} style={{marginRight: 10}}/>Назад
          </button>
        </div>

        <h1>Статистика по виджетам</h1>

        <h2>Смотрите статистику по нескольким виджетам одновременно</h2>

        <div className='extended-header'>
          <div>
            <DatePicker 
              startDate={startDate} 
              setStartDate={setStartDate} 
              endDate={endDate} 
              setEndDate={setEndDate}
            />
            <GroupBy 
              groupBy={groupBy}
              setGroupBy={setGroupBy} 
            />
          </div>
          <div>
            <MultiSelect
              options={widgetList}
              value={selectedWidgets}
              onChange={handleChange}
              data={data}
            />
            <SelectBy
              options={widgetList}
              selectedWidgets={selectedWidgets}
              setSelectedWidgets={setSelectedWidgets}
              activeWidgetIds={activeWidgetIds}
            />
          </div>
        </div>

        <div className="extended-widgets-info">
          <p>Всего виджетов - { Object.keys(widgetList).length }</p>
          <p>Выбрано виджетов - {selectedWidgets.length}</p>
          <p>Активных виджетов - {activeWidgetIds.length}</p>
          <div className="extended-widget-badge-list">
            {selectedWidgetsList.map((widget) => (
              <span
                className="extended-widget-badge"
                key={widget.id}
              >
                <span className="extended-widget-badge__name">
                  {widget.name}
                </span>

                <button
                  type="button"
                  className="extended-widget-badge__remove"
                  onClick={() => removeWidget(widget.id)}
                >
                  ×
                </button>
              </span>
            ))}
          </div>
        </div>

        <div className='extended-chart'>
          <StatsChart 
            data={result_summ} 
            groupBy={groupBy} 
          />
        </div>

        <div className='extended-table'>
          <Table 
            data={result_summ} 
            groupBy={groupBy} 
          />
        </div>

      </div>
    </div>
  )
}


function mapStateToProps(state){
  return{
    currentSiteID: state.siteInfo.site.id,
    startDate_store: state.siteInfo.site.statisticsDate.startFormatted,
    endDate_store: state.siteInfo.site.statisticsDate.endFormatted,
    groupByQuery: state.siteInfo.site.groupBy,
  }
}


function mapDispatchToProps(dispatch){
  return {
    setAlert
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PageIncomeExtended)